$(document).ready(function() {

// Compare Table

    $("table.compare-table tbody").hide();
    $("table.compare-table thead td").hide();


// Deny selection th
    $("table.compare-table thead th").disableSelection();

});

function gup( name )
{
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( window.location.href );
    if( results == null )
        return null;
    else
        return results[1];
}

jQuery.fn.extend({
    disableSelection : function() {
        this.each(function() {
            // Safari/Chrome/Konqueror/Opera/Mozilla/ie
            this.onselectstart = function() { return false; };
            this.unselectable = "on";
            jQuery(this).css('-moz-user-select', 'none');
            jQuery(this).css('-webkit-user-select', 'none');
            jQuery(this).css('-khtml-user-select', 'none');
        });
    }
});

var table_text = "";
var count = 1;
var i;
var temp, temp1 = "";
var cars_models_array = new Array();
var cars_parameters = new Object();
var parameters_names = new Object();

$(document).ready(function() {

    var carId = parseInt($('#compare-car-id').html());
    if (!carId) {
        return;
    }

    $.ajax({
        type : "GET",
        cache : false,
        url : "/api/cars/equipments/" + carId,
        dataType : "xml",
        error : function(exml, textStatus, errorThrown) {
            console.log('Ajax error. Sorry.');
        },
        success : function(xml) {
            //Создаем таблицу
            $(xml).find('params').find('block').each(function() {
                i = (count++);
                table_text += "<div class=\"compare-table-item\">";
                table_text += "<div class=\"compare-table-body\">";
                table_text += "<table class=\"compare-table\">";
                table_text += "<thead class=\"close\">";
                table_text += "<tr>";
                table_text += "<th class=\"first-cell\"> <span>" + $(this).attr('name') + "</span></th>";
                table_text += "<td id=\"TD1_" + i + "\">&nbsp;</td>";
                table_text += "<td id=\"TD2_" + i + "\" class=\"empty-cell\">&nbsp;</td>";
                table_text += "<td id=\"TD3_" + i + "\" class=\"empty-cell last-cell\">&nbsp;</td>";
                table_text += "</tr>";
                table_text += "</thead>";
                table_text += "</table>";
                table_text += "<div class=\"compare-module\">";
                table_text += "<table class=\"compare-table\">";
                table_text += "<tbody>";

                $(this).find('elem').each(function() {
                    table_text += "<tr id=\"tr_" + $(this).attr('id') + "\"></tr>";
                    cars_parameters[$(this).attr('id')] = new Object;
                    parameters_names[$(this).attr('id')] = $(this).text();
                });
                table_text += "</tbody>";
                table_text += "</table>";
                table_text += "</div>";
                table_text += "</div>";
                table_text += "</div>";
            });
            // end of Создаем таблицу

            //Заполняем cars_models_array
            $(xml).find('models').find('model').each(function() {
                if(cars_models_array.length == 0) {
                    $("#select_cars_1").append($("<option value=\"" + $(this).attr("name") + "\">" + $(this).attr("name") + "</option>"));
                }
                cars_models_array.push($(this).attr("name"));
                temp = $(this).attr("name");
                $(this).find('block').find('param').each(function() {
                    temp1 = $(this).text();
                    if(temp1 == "true") {
                        temp1 = "<img src=\"/images/icons/check-mark.png\">";
                    }
                    if(temp1 == "false") {
                        temp1 = "<img src=\"/images/icons/minus.png\">";
                    }
                    cars_parameters[$(this).attr('id')][temp] = temp1;
                });
            });
            //end of Заполняем cars_models_array

            $("#compare-table").html(table_text);

            $(".compare-module").hide();
            $("table.compare-table thead tr td").hide();

            $("table.compare-table thead tr th.first-cell").click(function() {
                $(this).parent().parent().toggleClass("active close");
                $(this).parents('.compare-table-body:first').find(".compare-module").slideToggle(300);
                $(this).parent().find("td").toggle();
                check_first_open_th();
            });

            setTimeout(function(){
                $('.compare-table-item:first table.compare-table thead tr th.first-cell').trigger('click');
            }, 1000);

            select_change();
            $("th:first").click();

            // Deny selection th
            $("table.compare-table thead th").disableSelection();
            $(xml).find('selectId').find('el').each(function() {
                if ($(this).attr('id') == gup( 'sel1' )) {
                    $('#select_cars_1').val($(this).attr('name'));
                    $('#select_cars_1').attr('value', $(this).attr('name'));
                    $('#select_cars_1').change();

                }

                if ($(this).attr('id') == gup( 'sel2' )) {
                    $('#select_cars_2').val($(this).attr('name'));
                    $('#select_cars_2').attr('value', $(this).attr('name'));
                    $('#select_cars_2').change();
                }

                if ($(this).attr('id') == gup( 'sel3' )) {
                    $('#select_cars_3').val($(this).attr('name'));
                    $('#select_cars_3').attr('value', $(this).attr('name'));
                    $('#select_cars_3').change();
                }
            });
//			$(".selectbox").selectBox();

        } // end of ajax.success
    });
    // end of ajax

    // checkbox

    $('.checkbox__field_hide input').change(function(){
        var countCol = $(this).closest('.simple-tabs__item').find('table>thead>tr:first>th').length - 1;
        $(this).closest('.simple-tabs__item').find('table>tbody>tr').each(function(){
            $(this).find('td[colspan=' + countCol + ']').closest('tr').toggleClass('active');
        });
    });

    // selectbox

    $(".selectbox").change(function() { select_change();
    });

});

//document.ready

function check_first_open_th() {

    if($("#select_cars_2").val() == "" && $("#select_cars_3").val() == "") {
        $('thead.active').each(function() {
            $(this).find('tr td:eq(1)').html('&nbsp;');
            $(this).find('tr td:eq(2)').html('&nbsp;');

            $(this).parent().next().find('tr:first td:eq(1)').html('&nbsp;');
            $(this).parent().next().find('tr:first td:eq(2)').html('&nbsp;');
        });
        $('thead.active:first').parent().next().find('tr:first td:eq(1)').html('<p class=\"please-select\"><span>Пожалуйста, выберите версию для сравнения</span></p>');
        $('thead.active:first').parent().next().find('tr:first td:eq(2)').html('<p class=\"please-select\"><span>Пожалуйста, выберите версию для сравнения</span></p>');
    }
    if($("#select_cars_2").val() == "" && $("#select_cars_3").val() != "") {
        $('thead.active').each(function() {
            $(this).find('tr td:eq(1)').html('&nbsp;');

            $(this).parent().next().find('tr:first td:eq(1)').html('&nbsp;');
        });

        $('thead.active:first').parent().next().find('tr:first td:eq(1)').html('<p class=\"please-select\"><span>Пожалуйста, выберите версию для сравнения</span></p>');
    }

    //alert($("#select_cars_2").val());
    //alert( $("#select_cars_3").val());

    if($("#select_cars_2").val() != "" && $("#select_cars_3").val() == "") {
        $('thead.active').each(function() {
            flag = 2;
            if($(this).parent().next().find('tr:first td:eq(' + flag + ')').length == 0) {
                flag = 1;
            }

            $(this).find('tr td:eq(2)').html('&nbsp;');
            $(this).parent().next().find('tr:first td:eq(' + flag + ')').html('&nbsp;');
        });
        flag = 2;
        if($('thead.active:first').parent().next().find('tr:first td:eq(' + flag + ')').length == 0) {
            flag = 1;
        }
        $('thead.active:first').parent().next().find('tr:first td:eq(' + flag + ')').html('<p class=\"please-select\"><span>Пожалуйста, выберите версию для сравнения</span></p>');
    }
    else {

    }
}

function select_change() {
    var sel_1 = $("#select_cars_1").val();
    var sel_2 = $("#select_cars_2").val();
    var sel_3 = $("#select_cars_3").val();

    var sel_1_index = $("#select_cars_1")[0].selectedIndex;
    var sel_2_index = $("#select_cars_2")[0].selectedIndex;
    var sel_3_index = $("#select_cars_3")[0].selectedIndex;

//	alert(sel_1);
//	alert(sel_2);
//	alert(sel_3);

    for( i = 1; i < 4; i++) {
        $("#select_cars_" + i).empty();
    }

    //Заполняем Select 1
    $(cars_models_array).each(function(i, val) {
        //if((val != sel_2) && (val != sel_3)) {
        $("#select_cars_1").append($("<option value=\"" + val + "\" selected>" + val + "</option>"));
        //}
    });

    //Заполняем Select 2
    $("#select_cars_2").append($("<option value=\"\">-- не выбрано --</option>"));
    $(cars_models_array).each(function(i, val) {
        //if((val != sel_1) && (val != sel_3)) {
        $("#select_cars_2").append($("<option value=\"" + val + "\">" + val + "</option>"));
        //}
    });

    //Заполняем Select 3
    $("#select_cars_3").append($("<option value=\"\">-- не выбрано --</option>"));
    $(cars_models_array).each(function(i, val) {
        //if((val != sel_1) && (val != sel_2)) {
        $("#select_cars_3").append($("<option value=\"" + val + "\">" + val + "</option>"));
        //}
    });


    //Возвращаем значения Select

    $("#select_cars_1").attr("value", sel_1);
    $("#select_cars_2").attr("value", sel_2);
    $("#select_cars_3").attr("value", sel_3);


    $("#select_cars_1")[0].selectedIndex = sel_1_index;
    $("#select_cars_2")[0].selectedIndex = sel_2_index;
    $("#select_cars_3")[0].selectedIndex = sel_3_index;

    for( i = 1; i < count; i++) {
        $("#TD1_" + i).html(sel_1);
        $("#TD2_" + i).html(sel_2);
        if(sel_2 != "") {
            $("#TD2_" + i).removeClass("empty-cell");
        } else {
            $("#TD2_" + i).addClass("empty-cell");
        }
        $("#TD3_" + i).html(sel_3);
        if(sel_3 != "") {
            $("#TD3_" + i).removeClass("empty-cell");
        } else {
            $("#TD3_" + i).addClass("empty-cell");
        }
    }

    for(var key in parameters_names) {
        if(cars_parameters[key][sel_1]) {
        } else {
            cars_parameters[key][sel_1] = "<img src=\"/images/icons/minus.png\">";;
        }
        if(cars_parameters[key][sel_2]) {
        } else {
            cars_parameters[key][sel_2] = "<img src=\"/images/icons/minus.png\">";;
        }
        if(cars_parameters[key][sel_3]) {
        } else {
            cars_parameters[key][sel_3] = "<img src=\"/images/icons/minus.png\">";;
        }
        temp = "<th class=\"first-cell\">" + parameters_names[key] + "</th>";
        if((sel_2 == "") && (sel_3 == "")) {
            temp += "<td>" + cars_parameters[key][sel_1] + "</td><td class=\"two-cell empty-cell last-cell\" colspan=\"2\">&nbsp;</td>";
        }

        if((sel_2 == "") && (sel_3 != "")) {
            temp += "<td>" + cars_parameters[key][sel_1] + "</td><td class=\"empty-cell\">&nbsp;</td><td class=\"last-cell\">" + cars_parameters[key][sel_3] + "</td>";
        }

        if((sel_2 != "") && (sel_3 == "")) {
            if(cars_parameters[key][sel_1] == cars_parameters[key][sel_2]) {
                temp += "<td class=\"two-cell\" colspan=\"2\">" + cars_parameters[key][sel_1] + "</td><td class=\"empty-cell\">&nbsp;</td>";
            } else {
                temp += "<td>" + cars_parameters[key][sel_1] + "</td><td>" + cars_parameters[key][sel_2] + "</td><td class=\"empty-cell\">&nbsp;</td>";
            }
        }

        if((sel_2 != "") && (sel_3 != "")) {
            temp1 = "";
            if(cars_parameters[key][sel_1] == cars_parameters[key][sel_2]) {
                if(cars_parameters[key][sel_2] == cars_parameters[key][sel_3]) {
                    temp1 = "<td class=\"three-cell last-cell\" colspan=\"3\">" + cars_parameters[key][sel_1] + "</td>";
                } else {
                    temp1 = "<td class=\"two-cell\" colspan=\"2\">" + cars_parameters[key][sel_1] + "</td><td class=\"last-cell\">" + cars_parameters[key][sel_3] + "</td>";
                }
            } else {
                temp1 = "<td>" + cars_parameters[key][sel_1] + "</td>";
                if(cars_parameters[key][sel_2] == cars_parameters[key][sel_3]) {
                    temp1 += "<td class=\"two-cell last-cell\" colspan=\"2\">" + cars_parameters[key][sel_2] + "</td>";
                } else {
                    temp1 += "<td>" + cars_parameters[key][sel_2] + "</td><td class=\"last-cell\">" + cars_parameters[key][sel_3] + "</td>";
                }
            }

            if(temp1 == "") {
                temp += "<td>" + cars_parameters[key][sel_2] + "</td><td>" + cars_parameters[key][sel_3] + "</td>";
            } else {
                temp += temp1;
            }
        }
        temp += "</th>";

        $("#tr_" + key).html(temp);
    }
    check_first_open_th();
}

